export class ServiceAdapter {
  static adaptItems(items) {
    throw new Error(
      `${this.constructor.name} has not implemented method adaptItems that expected to receive ${items}`,
    );
  }

  static adaptItem(item) {
    throw new Error(
      `${this.constructor.name} has not implemented method adaptItem that expected to receive ${item}`,
    );
  }
}
